export const REDUX_DATA_TYPES = {
  ASSIGN_LOADS: 'ASSIGN_LOADS',
  ASSIGN_TRUCKS: 'ASSIGN_TRUCKS',
  MATCH_TRUCKS: 'MATCH_TRUCKS',
  MATCH_LOADS: 'MATCH_LOADS',
  SHOW_MARKETPLACE: 'SHOW_MARKETPLACE',
  TAG: 'TAG',
  CARRIERS: 'CARRIERS',
  SHIPPERS: 'SHIPPERS',
  TEAMS: 'TEAMS',
  SELECTED_ROWS: 'SELECTED_ROWS',
  RESET_SELECTED_ROWS: 'RESET_SELECTED_ROWS'
}

export const dispatchShowMarketplace = (isVisible) => (dispatch) => dispatch({
  type: REDUX_DATA_TYPES.SHOW_MARKETPLACE,
  payload: isVisible
})

export const dispatchTag = (tag) => (dispatch) => dispatch({
  type: REDUX_DATA_TYPES.TAG,
  payload: tag
})

export const dispatchCarriers = (carriers) => (dispatch) => dispatch({
  type: REDUX_DATA_TYPES.CARRIERS,
  payload: carriers
})

export const dispatchShippers = (shippers) => (dispatch) => dispatch({
  type: REDUX_DATA_TYPES.SHIPPERS,
  payload: shippers
})

export const dispatchSelectedRows = (selectedRows) => (dispatch) => dispatch({
  type: REDUX_DATA_TYPES.SELECTED_ROWS,
  payload: selectedRows
})

export const dispatchTeams = (teams) => (dispatch) => dispatch({
  type: REDUX_DATA_TYPES.TEAMS,
  payload: teams
})

export const resetSelectedRows = () => (dispatch) => dispatch({ type: REDUX_DATA_TYPES.RESET_SELECTED_ROWS })
